import type { Campaign } from './campaignsApi';

const activeStatuses = ['ativa', 'active', 'running', 'otimizando'];
const pausedStatuses = ['pausada', 'paused'];
const draftStatuses = ['briefing', 'draft', 'rascunho', 'backlog', 'planejada', 'em_revisao', 'review', 'validacao', 'erro', 'failed'];
const lockedStatuses = ['publicando', 'publishing', 'deleting', 'deleted', 'delete_failed'];
const terminalStatuses = ['concluida', 'completed', 'arquivada', 'archived'];

export function campaignStatusOptions(campaign: Campaign) {
  const linked = Boolean(campaign.meta_campaign_id || campaign.google_campaign_id);
  if (lockedStatuses.includes(campaign.status)) return [];
  if (linked) {
    if (terminalStatuses.includes(campaign.status)) return [];
    if (pausedStatuses.includes(campaign.status)) return [{ value: 'ativa', label: 'Retomar nas origens' }];
    return [{ value: 'pausada', label: 'Pausar nas origens' }];
  }
  if (!draftStatuses.includes(campaign.status) && !terminalStatuses.includes(campaign.status)) return [];
  return [
    { value: 'draft', label: 'Rascunho' },
    { value: 'planejada', label: 'Planejada' },
    { value: 'em_revisao', label: 'Em revisão' },
  ].filter(option => option.value !== campaign.status);
}

export function campaignStatusHint(campaign: Campaign) {
  if (campaign.meta_campaign_id || campaign.google_campaign_id) return 'A alteração será confirmada nas origens.';
  if (activeStatuses.includes(campaign.status) || pausedStatuses.includes(campaign.status)) {
    return 'Origem não vinculada. Se a campanha já existe na plataforma, vincule-a para alterar o status online.';
  }
  if (lockedStatuses.includes(campaign.status)) return 'Aguarde a operação em andamento.';
  return 'Para aprovar ou publicar, abra o painel da campanha.';
}

export function googleCampaignDestination(campaign: Campaign) {
  const google = ['google', 'google_ads'].includes(campaign.ad_platform || '')
    || Boolean(campaign.google_campaign_id);
  if (!google) return null;
  const raw = campaign.landing_url || campaign.target_audience?.landing_url;
  try {
    const url = new URL(raw);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}
